import styled from 'styled-components';

export const Container = styled.div``;

export const Body = styled.div``;

export const Padding = styled.div`
  padding: 0 30px;
`;
